module.exports = __webpack_public_path__ + "img/empty-state.e4f2e547.png";